import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const OriginsWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default OriginsWrapper